import {ReactComponent as uploadIcon} from "../../../assets/images/studio/actions/upload.svg";
import {PROJECT_ASSETS, WHITEBOARD_ACTIONS} from "../../../constants/constants";
import {actions, ActionType, category, ProjectAssetsType, StudioActionTypes} from "../../../constants/enums";
import {ReactComponent as instructionsIcon} from "../../../assets/images/studio/actions/instructions.svg";
import {ReactComponent as audioIcon} from "../../../assets/images/studio/actions/audio.svg";
import {ReactComponent as videoIcon} from "../../../assets/images/studio/actions/video.svg";
import {ReactComponent as otherIcon} from "../../../assets/images/studio/actions/other.svg";
import {ReactComponent as libraryIcon} from "../../../assets/images/studio/actions/library.svg";
import {ReactComponent as musicoLibraryIcon} from "../../../assets/images/studio/actions/muscioLibrary.svg";
import {ReactComponent as linkIcon} from "../../../assets/images/studio/actions/link.svg";
import {ReactComponent as whiteboardIcon} from "../../../assets/images/studio/actions/whiteboard.svg";
import {ReactComponent as moreIcon} from "../../../assets/images/studio/actions/more.svg";
import {ReactComponent as uploadImage} from "../../../assets/images/studio/actions/take-photo.svg";
import {disabledDark, lightBorder} from "../../../themes/colors";
import {getUserReady, isStudent, isGuest} from "../../../utils/userUtility";
import {autorun} from "mobx";
import marketingView from '../../../stores/ShareLinkStore'
import { isMobile } from "../../../utils/screenUtility";

class StudioActionStore {
    actionList = {};

    constructor() {
        this.listener = autorun(() => {
            if (getUserReady() || isGuest()) {
                this.actionList[StudioActionTypes.NotationUpload] = {
                    title: 'studio.assignment.action.uploadNotationFile',
                    icon: uploadIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Notation],
                    step: ProjectAssetsType.Notation,
                    type: ActionType.Main,
                    analyticsCategory: category.AddNotation
                };
                this.actionList[StudioActionTypes.Overview] = {
                    title: 'studio.assignment.action.writeInstructions',
                    icon: instructionsIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Text],
                    step: ProjectAssetsType.Text,
                    type: ActionType.Main,
                    analyticsCategory: category.AddInstructions
                };
                this.actionList[StudioActionTypes.AudioRecord] = {
                    title: 'studio.assignment.action.recordAudio',
                    icon: audioIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Audio],
                    step: ProjectAssetsType.Audio,
                    type: ActionType.Main,
                    analyticsCategory: category.RecordAudio
                };
                this.actionList[StudioActionTypes.VideoRecord] = {
                    title: 'studio.assignment.action.recordVideo',
                    icon: videoIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Video],
                    step: ProjectAssetsType.Video,
                    type: ActionType.Main,
                    analyticsCategory: category.RecordVideo
                };
                this.actionList[StudioActionTypes.MoreAudio] = {
                    title: 'studio.assignment.action.multiple.moreAudio',
                    icon: moreIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Audio],
                    step: ProjectAssetsType.Audio,
                    type: ActionType.Multiple,
                }
                this.actionList[StudioActionTypes.MoreVideo] = {
                    title: 'studio.assignment.action.multiple.moreVideo',
                    icon: moreIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Video],
                    step: ProjectAssetsType.Video,
                    type: ActionType.Multiple
                }
                this.actionList[StudioActionTypes.Other] = {
                    title: 'studio.assignment.action.addOther',
                    icon: otherIcon,
                    asset: {
                        color: disabledDark,
                        bgColor: lightBorder
                    },
                    type: ActionType.Main
                };
                this.actionList[StudioActionTypes.AudioUpload] = {
                    title: 'studio.assignment.action.other.uploadAudio',
                    icon: uploadIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Audio],
                    step: ProjectAssetsType.Audio,
                    type: isStudent() ? ActionType.Main : ActionType.Other,
                    hidden: false,
                    analyticsAction: actions.Upload,
                    analyticsCategory: category.AddAudio
                };
                this.actionList[StudioActionTypes.AudioLibrary] = {
                    title: 'studio.assignment.action.other.addFromAudioLibrary',
                    icon: libraryIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Audio],
                    step: ProjectAssetsType.Audio,
                    type: ActionType.Other,
                    analyticsAction: actions.Library,
                    analyticsCategory: category.AddAudio,
                    hidden: marketingView
                };
                this.actionList[StudioActionTypes.AudioMusicoLibrary] = {
                    title: 'studio.assignment.action.other.addFromMusicoLibrary',
                    icon: musicoLibraryIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Audio],
                    step: ProjectAssetsType.Audio,
                    type: ActionType.Other,
                    analyticsAction: actions.MusicoSamples,
                    analyticsCategory: category.AddAudio
                };
                this.actionList[StudioActionTypes.VideoLink] = {
                    title: 'studio.assignment.action.other.addLinkedVideo',
                    icon: linkIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Video],
                    step: ProjectAssetsType.Video,
                    type: ActionType.Other,
                    analyticsAction: actions.Link,
                    analyticsCategory: category.AddVideo
                };
                this.actionList[StudioActionTypes.VideoUpload] = {
                    title: 'studio.assignment.action.other.uploadVideo',
                    icon: uploadIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Video],
                    step: ProjectAssetsType.Video,
                    type: isStudent() ? ActionType.Main : ActionType.Other,
                    hidden: false,
                    analyticsCategory: category.AddVideo,
                    analyticsAction: actions.Upload
                };
                this.actionList[StudioActionTypes.ImageUpload] = {
                    title: 'studio.assignment.action.imageUpload',
                    icon: uploadImage,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Image],
                    step: ProjectAssetsType.Image,
                    type: ActionType.Main,
                    analyticsCategory: category.AddPhoto,
                };
                this.actionList[StudioActionTypes.WhiteboardMultiple] = {
                    title: 'studio.assignment.action.multiple.createWhiteboard',
                    icon: whiteboardIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Image],
                    step: ProjectAssetsType.Image,
                    type: ActionType.Multiple,
                };
                this.actionList[StudioActionTypes.Whiteboard] = {
                    title: 'studio.assignment.action.other.createWhiteboard',
                    icon: whiteboardIcon,
                    asset: PROJECT_ASSETS[ProjectAssetsType.Image],
                    step: ProjectAssetsType.Image,
                    type: ActionType.Other,
                };
                WHITEBOARD_ACTIONS.forEach(wbAction => {
                    this.actionList[wbAction.type] = {
                        title: wbAction.key,
                        icon: wbAction.icon,
                        asset: PROJECT_ASSETS[ProjectAssetsType.Image],
                        step: ProjectAssetsType.Image,
                        type: ActionType.Other,
                        isWbAction: true,
                        analyticsCategory: category.AddWhiteboard,
                        analyticsAction: wbAction.type
                    }
                })

                this.studentMainAddActions = [
                    StudioActionTypes.AudioRecord,
                    StudioActionTypes.AudioUpload,
                    StudioActionTypes.VideoRecord,
                    StudioActionTypes.VideoUpload,
                    StudioActionTypes.ImageUpload,
                    StudioActionTypes.WhiteboardMultiple,
                ]

                this.teacherMainAddActions = [
                    StudioActionTypes.Overview,
                    StudioActionTypes.NotationUpload,
                    StudioActionTypes.AudioRecord,
                    StudioActionTypes.MoreAudio,
                    StudioActionTypes.VideoRecord,
                    StudioActionTypes.MoreVideo,
                    StudioActionTypes.ImageUpload,
                    StudioActionTypes.WhiteboardMultiple,
                ]

                this.teacherMainCreateActions = [
                    StudioActionTypes.NotationUpload,
                    StudioActionTypes.Overview,
                    StudioActionTypes.AudioRecord,
                    StudioActionTypes.VideoRecord,
                    StudioActionTypes.Other
                ]

                this.teacherOtherCreateActions = [
                    StudioActionTypes.AudioLibrary,
                    StudioActionTypes.AudioMusicoLibrary,
                    StudioActionTypes.VideoLink,
                    StudioActionTypes.VideoUpload,
                    StudioActionTypes.ImageUpload,
                    StudioActionTypes.Whiteboard
                ]

                this.mobileTeacherMainCreateActions = [
                    StudioActionTypes.ImageUpload,
                    StudioActionTypes.Overview,
                    StudioActionTypes.AudioRecord,
                    StudioActionTypes.VideoRecord,
                    StudioActionTypes.Other
                ]

                this.mobileTeacherOtherCreateActions = [
                    StudioActionTypes.NotationUpload,
                    StudioActionTypes.AudioLibrary,
                    StudioActionTypes.AudioMusicoLibrary,
                    StudioActionTypes.VideoLink,
                    StudioActionTypes.VideoUpload,
                    StudioActionTypes.Whiteboard
                ]
            }

        })
    }

    mapActions(actions) {
        return actions?.map(key => {
            return {id: key,...this.actionList[key]}
        })
    }

    get mainActionsForWizard() {

        if (isMobile()) {
            return this.mapActions(this.mobileTeacherMainCreateActions)
        }

        return this.mapActions(this.teacherMainCreateActions)
    }

    get otherActionsForWizard() {

        if (isMobile()) {
            return this.mapActions(this.mobileTeacherOtherCreateActions)
        }

        return this.mapActions(this.teacherOtherCreateActions)
    }

    get mainActionsForAdd() {
        const list = (isStudent() ? this.studentMainAddActions : this.teacherMainAddActions) || [];
        return this.mapActions(list)//.filter(action => action.id !== StudioActionTypes.Other && !action.hidden && (action.type === ActionType.Main || action.type === ActionType.Multiple))
    }

    otherActionsForStep = (step) => {
        return Object.keys(this.actionList).map(key => {
            return {id: key, ...this.actionList[key]}
        }).filter(action => action.type === ActionType.Other && action.step === step //&& !action.hidden
            && (action.step !== ProjectAssetsType.Image || (action.step === ProjectAssetsType.Image && action.isWbAction)))
    }


    getActionById = (id) => {
        return {id, ...this.actionList[id]};
    }
}

const studioActionStore = new StudioActionStore();
export default studioActionStore;

